<template>
    <v-list-item-avatar
            size="60"
            color="grey"
    >
    <span class="white--text headline">
      <select class="select" @change="update">
          <option class="option" value="">?</option>
          <option
              v-for="poule in poules"
              :key="poule.id"
              class="option"
              :value="poule.id"
              :selected="participant.poule_id == poule.id"
          >
            {{ poule.name }}
          </option>
        </select>
    </span>
    </v-list-item-avatar>
</template>

<script>
import PouleModel from '@/models/PouleModel';
import ParticipantModel from '@/models/ParticipantModel';

export default {
  name: 'ParticipantPoule',

  props: {
    participantId: {
      type: String,
      required: true
    }
  },

  data: () => ({
  }),

  computed: {
    poules () {
      return PouleModel.query().orderBy('name').get();
    },

    participant () {
      return ParticipantModel.query().with('poule').find(this.participantId);
    }
  },

  methods: {
    update (e) {
      ParticipantModel.update({
        id: this.participantId,
        poule_id: e.target.value
      });
    }
  }

};
</script>

<style scoped>

</style>